import { render, staticRenderFns } from "./General.vue?vue&type=template&id=7850e0d8&scoped=true"
import script from "./General.vue?vue&type=script&lang=ts"
export * from "./General.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7850e0d8",
  null
  
)

export default component.exports